import { all, fork } from "redux-saga/effects";
import { watchHttpAction } from "./httpRequestSaga";
import { rootSaga as childRootSaga } from "@amzn/msa-static-website-development";

function* rootSaga(): Generator {
  yield all([
    watchHttpAction(),
    // Child package sagas (auto-includes new feature sagas when child adds them)
    fork(childRootSaga),
  ]);
}

export default rootSaga;
